<template>
    <v-frontend>
        <v-wrapper :padding="true" element="main">
            <v-box element="section">
                <div class="privacy">
                    <h1>Misión MartillerosUnidos.com</h1>
                    <p>
                      Somos Martilleros Unidos Zona Oeste. Un grupo de Inmobiliarias con Martilleros y Corredores Públicos debidamente Matriculados, generando una red dinámica, moderna, unificando criterios de trabajo y  profesionalismo.
                    </p>
                    <p>
                      Entendemos que para avanzar es necesario trabajar en equipo, con compromiso, pasión y vocación de servicio. MartillerosUnidos.com es un sitio dedicado a facilitar alquileres, buscar una vivienda o emprender un negocio, principalmente en Zona Oeste de Gran Buenos Aires y alrededores.
                    </p>

                    <!-- <p>Diariamente se publican en MartillerosUnidos.com miles de clasificados en diversos países donde se incluyen apartamentos, pisos, departamentos, casas, hoteles, cabañas, hosterías, locales comerciales y oficinas, entre otros.</p>

                    <p>MartillerosUnidos.com funciona como un marketplace o plataforma de alquileres en diversos países, en el cual profesionales de cada sector y ciudad publican sus productos o servicios bajo el formato actual de clasificados.</p>
                    <p>Invitamos a usuarios, clientes y partners a participar utilizando la plataforma MartillerosUnidos.com.</p>
                    <p>Puedes enviar sugerencias o propuestas por medio del formulario de contacto.</p>
                    <P>Somos libres si tenemos un propósito, una misión.</P> -->
                    <p>Muchas gracias.</p>
                    <p>
                        Grupo Martilleros Unidos
                        <br>01.12.2020
                    </p>
                </div>
            </v-box>
        </v-wrapper>
    </v-frontend>
</template>

<script>
export default {}
</script>

<style lang="scss">
.privacy {
    padding: 2rem;
    h1 {
        margin-bottom: 2rem;
        text-transform: uppercase;
        text-align: center;
        font-weight: 600;
        font-size: 1.8rem;
    }
    h2 {
        margin-bottom: 1rem;
        font-weight: 600;
        font-size: 1.4rem;
    }
    p {
        margin-bottom: 1rem;
        &:last-child {
            margin-bottom: 0;
        }
    }
    @media (max-width: 992px) {
        padding: 1rem;
    }
}
</style>
